import { useEffect, useState } from 'preact/hooks';
import { useHud } from '../context.js';
import type { VaultStore } from '../store.js';

/**
 * Subscribe to store changes.
 *
 * Returns the store itself and re-renders on every change. The store is
 * mutable rather than immutable-with-new-references, so a version counter is
 * what drives updates — cheaper than cloning the whole vault on each keystroke.
 */
export function useStore(): VaultStore {
  const { store } = useHud();
  const [, setVersion] = useState(0);

  useEffect(() => store.subscribe(() => setVersion((v) => v + 1)), [store]);

  return store;
}

/** Optimistic content of one file, or `undefined` if it doesn't exist. */
export function useVaultText(path: string): string | undefined {
  return useStore().get(path);
}
